import logoPragmatic from '@/assets/images/logo/logo_pragmatic_play.png'
import logoMicrogaming from '@/assets/images/logo/logo_microgaming.png'
import logoNetent from '@/assets/images/logo/logo_netend.png'
import logoBng from '@/assets/images/logo/logo_bng.png'
import logoPlayngo from '@/assets/images/logo/logo_playngo.png'
import logoNolimit from '@/assets/images/logo/logo_Nolimit_City.png'
import logoJili from '@/assets/images/logo/logo_JILI.png'
import logoBgaming from '@/assets/images/logo/logo_bgaming.png'
import logoCq9 from '@/assets/images/logo/logo_CQ9.png'
import logoPlaytech from '@/assets/images/logo/logo_PlayTech.png'
import logoHabanero from '@/assets/images/logo/logo_Habanero.png'
import logoWazdan from '@/assets/images/logo/logo_Wazdan.png'
import logoRedtiger from '@/assets/images/logo/logo_redtiger.png'
import logoFatpanda from '@/assets/images/logo/logo_FatPanda.png'
import logoJdb from '@/assets/images/logo/logo_JDB.png'
import logoRelax from '@/assets/images/logo/logo_Relax Gaming .png'
import logo1x2 from '@/assets/images/logo/logo_1X2 Gaming .png'
import logoRevolver from '@/assets/images/logo/logo_revolver.png'

/** 벤더 name → 로고 이미지 매핑 (게임 목록 페이지 왼쪽 위 로고) */
export const VENDOR_LOGO_MAP = {
  'プラグマティック': logoPragmatic,
  'マイクロゲーミング': logoMicrogaming,
  'ネットエント': logoNetent,
  'ブウンゴ': logoBng,
  'プレインゴー': logoPlayngo,
  'ノーリミット・シティ': logoNolimit,
  'JILI': logoJili,
  'BGAMING': logoBgaming,
  'CQ9': logoCq9,
  'プレイテック': logoPlaytech,
  'ハバネロ': logoHabanero,
  'ワズダン': logoWazdan,
  'レッド・タイガー': logoRedtiger,
  'ファット・パンダ': logoFatpanda,
  'JDB': logoJdb,
  'RELAX GAMING': logoRelax,
  '1X2 GAMING': logo1x2,
  'リボルバー': logoRevolver,
}
